import { MultiAutocompleteOptionProps } from '@dev/ee-components';

export enum AutocompleteCategories {
    List = 'List',
    Segment = 'Segment',
}

export interface OptionProps extends MultiAutocompleteOptionProps {
    isAllContacts: boolean;
}
